import {RouteObject} from "react-router-dom";
import {REWARD_DETAILS} from "../../constants/urls";

export default [
    {
        index: true,
        lazy: () => import("modules/profile/routes/Profile"),
    },
] as RouteObject[];
